/* ============
 * Municipality Transformer
 * ============
 *
 * Municipality Transformer
 */

import Transformer from './transformer';

export default class MunicipalityTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      countryId: item.country_id,
      municipalityId: item.municipalityId,
      name: item.name,
    };
  }

  static send(item) {
    return {
      id: item.id,
      country_id: item.countryId,
      municipalityId: item.municipalityId,
      name: item.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/municipality.js